import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// confia
ReactDOM.render(<App />, document.getElementById('root'))
